import { FaCheck } from "react-icons/fa6";
import type { TimelineProps } from "./interface";
import { useTimeline } from "./useTimeline";

export function Timeline({ totalSteps, currentStep }: TimelineProps) {
  const { useTimelineSteps } = useTimeline();
  const steps = useTimelineSteps(totalSteps, currentStep);

  return (
    <div className="flex items-center">
      {steps.map(({ stepNumber, isActive, isCompleted, isLast }) => {
        return (
          <div key={stepNumber} className="flex items-center">
            <div
              className={`
                w-8 h-8 rounded-full flex items-center justify-center text-[16px] font-semibold
                ${
                  isActive
                    ? "bg-[#4256C8] text-white"
                    : "bg-[#E9EBED] text-[#2F3941]"
                }
              `}
            >
              {isCompleted ? <FaCheck className="text-xs" /> : stepNumber}
            </div>

            {!isLast && <div className="h-px w-16 mx-4 bg-[#D8DCDE]" />}
          </div>
        );
      })}
    </div>
  );
}
